<div *ngIf="this.runningInIframe; else showPortalPage">
  <router-outlet></router-outlet>
  <lh-portal-page
    [sidebar]="false"
    [languages]="this.languages"
    (onLanguageChange)="this.onLanguageChange($event)"
    class="hidden"
  >
  </lh-portal-page>
</div>
<ng-template #showPortalPage>
  <lh-portal-page
    [portal-name]="'portal_name' | translate"
    [enableNotifications]="true"
    [enableAppLauncher]="true"
    [accessToken]="user.access_token"
    [environment]="this.environmentName.toLowerCase()"
    [sidebar]="false"
    [languages]="this.languages"
    [user]="this.userAvatar"
    [footerAdditionalLinks]="this.footerLinks"
    (onLanguageChange)="this.onLanguageChange($event)"
    (clickBrandLogo)="this.onBrandLogoClick()"
  >
    <ng-container main-menu-avatar>
      <patternlib-flyoutmenu-separator></patternlib-flyoutmenu-separator>

      <ng-container *ngFor="let link of navlinks">
        <patternlib-flyoutmenu-item
          label="{{ link.label | translate }}"
          [href]="link.uri"
          target="self"
        >
        </patternlib-flyoutmenu-item>
      </ng-container>

      <patternlib-flyoutmenu-separator></patternlib-flyoutmenu-separator>

      <patternlib-flyoutmenu-item
        (click)="onLogout()"
        label="{{ 'Log out' | translate }}"
      ></patternlib-flyoutmenu-item>
    </ng-container>
    <ng-container banner style="margin: 0%">
      <app-banner></app-banner>
    </ng-container>

    <ng-container content>
      <div class="wrapper bg-white">
        <div class="p-4 p-md-6">
          <router-outlet></router-outlet>
        </div>
      </div>
    </ng-container>
  </lh-portal-page>
</ng-template>
